import type {
  GoogleAnalytics4PluginConfig,
  LoadRequest,
} from "@foundation-player/api";
import { Media } from "./media_player.types";
import { Plugin } from "./media_plugin.js";

/**
 * For further information on the Google Analytics plugin, please also refer
 * to the corresponding API documentation in the Foundation Player documentation:
 *
 * @see https://docs.player.foundation/v2/api/type/load-request/#plugins
 * @see https://docs.player.foundation/v2/api/type/load-request/#foundationplugingoogleanalytics4
 * @see https://docs.player.foundation/v2/api/type/google-analytics4-plugin-config/
 */
export class PluginGa4 extends Plugin {
  // see EventTimeUpdate.#interval
  readonly #interval: number = 10;
  readonly #playerType: "audio" | "video";

  public constructor(media: Media, playerType: "audio" | "video") {
    super(media);
    this.#playerType = playerType;
  }

  public isEnabled(): boolean {
    return true;
  }

  public addFoundationLoadRequestPlugins(): LoadRequest["plugins"] {
    const googleAnalytics4PluginConfig: GoogleAnalytics4PluginConfig = {
      enabled: true,
      progressTrackingIntervalInSeconds: this.#interval,
      firstHeadline: this.media.tracking?.staticTitle,
      headline: this.media.headline,
      // Since we have no real lastPublicationDate (or lastModified) for videos in feed response,
      // we use firstPublicationDate here.
      // This is the way it was also used in former Publishing Player.
      lastPublicationDate: this.media.tracking?.firstPublicationDate,
      contentType: this.#playerType,
    };

    if (this.media.tracking?.technicalTags) {
      googleAnalytics4PluginConfig.tags = this.media.tracking.technicalTags;
    }

    if (this.media.tracking?.hiddenSources) {
      googleAnalytics4PluginConfig.editorialSources =
        this.media.tracking.hiddenSources.map((sources: string[]) =>
          sources.join(),
        );
    }

    return {
      "foundation.plugin.googleAnalytics4": googleAnalytics4PluginConfig,
    };
  }
}
